import apiClient from "./baseService";
import {handleAxiosError} from "./axiosErrorHandler";
import type {User} from "../types/domain/user";

export interface RegisterUserBodyType extends Pick<User, "properties" | "preferences"> {
    password: string;
    captcha: string;
    registrationEnablementCode: string;
}

export const registerUser = async (body: RegisterUserBodyType): Promise<User> =>
    await apiClient
        .post<User>("/register", body)
        .then((response) => response.data)
        .catch(handleAxiosError);
